import { render, staticRenderFns } from "./blogDetails.vue?vue&type=template&id=12de6832&scoped=true&"
import script from "./blogDetails.vue?vue&type=script&lang=js&"
export * from "./blogDetails.vue?vue&type=script&lang=js&"
import style0 from "./blogDetails.vue?vue&type=style&index=0&id=12de6832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de6832",
  null
  
)

export default component.exports